// The manifest kore's SearchBar renders for the templates table.
//
// Query only: templates have no facets worth filtering (a workspace holds
// tens of them at most, and the only fact on the row is its name) and no
// server-side search to sort or page — `filterRows` narrows the fetched list
// in the browser.
//
// The empty `filters` array is what makes that work rather than a compromise:
// `SearchBar` gates its free-text input on `query != null` alone
// (search-bar/index.tsx's `showQuery`), maps `filters` for its triggers — fine
// on `[]` — and leaves `FILTERED BY` unrendered while nothing is committed. So
// this renders exactly the query input the locations and screens pages render, and
// it is the same component doing it, which is the point: the page used to draw
// its own `InputGroup` search box, and a search box that looks different from
// the last one is a control people have to learn twice.

import type { FilterResponse } from "@pej/kore/components";

export const TEMPLATES_SEARCH_MANIFEST: FilterResponse = {
    filters: [],
    query: {
        // Read by `derivedPlaceholder` because `query.fields` is absent — with
        // fields declared, SearchBar builds its own placeholder and ignores
        // this one instead.
        placeholder: "Search templates…",
    },
};
